// import 'slick-carousel'
import GET_ARTICLES from '../plugins/getArticles'

const [ w, d, mq ] = [ window, document, window.matchMedia( "(max-width: 900px)" ) ]

const init = () => {

  w.jQuery = $

  /****************************
   * movie background
   */
  $.when(
    w.load['mainvisual'],
    $.getScript('/asset/js/vendor/jquery.mb.YTPlayer.min.js')
  ).then( () => {
    const $MV = $('[data-plugin="ytplayer"]')
    const param = id => `{
      videoURL: '${id}',
      containment: '${(mq.matches)? '.mainvisual__wrap':'body'}',
      mute: true,
      showControls: false,
      autoPlay: true,
      useOnMobile: true,
      showYTLogo: false,
      abundance: '${(mq.matches)? 0.01: 0.07}',
      stopMovieOnBlur: false,
      loop: true,
      startAt: 0,
      anchor: 'center,center',
      quality: 'default'
    }`.replace(/\n|\s/g,'')
    $MV.attr('data-property',param('8lRGuL92uxs'));
    $MV.YTPlayer()
    $MV.YTPPlay()
  });

  

  // ticker
  $.when(w.load['block-features-facilities']).then( () => {
    let makeItem = item => $(`
      <a href="${item.href}">
        <span class="cate">【${item.category.name}】</span>
        <span class="subject">${item.title.str_truncate(24)}</span>
      </a>
    `)[0]
    GET_ARTICLES('.block-ticker__article[data-plugin="getArticles"]', { makeItem })
  })
  // news
  $.when(w.load['block-news']).then( () => {
    let makeItem = item => $(`
      <li class="block-news-item">
        <a href="${item.href}">
          <span class="date">${item.date}</span>
          <span class="cate">【${item.category.name}】</span>
          <span class="subject">${item.title.str_truncate(24)}</span>
        </a>
      </li>
    `)[0]
    GET_ARTICLES('.block-news__list[data-plugin="getArticles"]', { makeItem })
  })
}

export default function HOME() {
  $( init )
}